<app-page-header title="Ancillary Markup Management" subtitle="Manage markup pricing for ancillary services">
    <div actions class="flex gap-2">
        <p-button label="Add New" (click)="openAdd()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-toast />

    <p-dialog [(visible)]="displayDialog" [modal]="true" [header]="dialogHeader" [closable]="true" [style]="{ width: '420px' }">
        <app-ancillary-markup-create-edit
            [mode]="dialogMode"
            [data]="dialogData"
            (cancel)="onDialogCancel()"
            (save)="onDialogSave($event)"
        ></app-ancillary-markup-create-edit>
    </p-dialog>

    <p-table
        #dt
        [value]="markups"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['provider', 'name']"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="provider" class="text-left">
                    <div class="flex items-center gap-2">
                        Provider
                        <p-sortIcon field="provider"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="provider" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="name" class="text-left">
                    <div class="flex items-center gap-2">
                        Name
                        <p-sortIcon field="name"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="name" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="price" class="w-[140px] text-left">
                    <div class="flex items-center gap-2">
                        Price
                        <p-sortIcon field="price"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="active" class="w-[120px] text-left">
                    <div class="flex items-center gap-2">
                        Active
                        <p-sortIcon field="active"></p-sortIcon>
                    </div>
                </th>
                <th class="w-[90px]"></th>
            </tr>
        </ng-template>

        <ng-template #body let-row>
            <tr>
                <td>{{ row.provider }}</td>
                <td>{{ row.name }}</td>
                <td>{{ row.price | number: '1.2-2' }}</td>
                <td>
                    <p-toggleswitch [(ngModel)]="row.active" (onChange)="onActiveToggle(row)"></p-toggleswitch>
                </td>
                <td class="text-right">
                    <div class="flex gap-2 justify-end">
                        <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="onEdit(row)"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
